import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageDefaults } from '@shared/defaults/local-storage-defaults';

@Component({
  selector: 'app-logout',
  imports: [],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss'
})
export class LogoutComponent implements OnInit {

  private router = inject(Router);
  
  ngOnInit(): void {
    console.log('Loging out');
    var redirectRoute = localStorage.getItem(LocalStorageDefaults.LogoutRedirectRoute);

    if (redirectRoute) {
      localStorage.removeItem(LocalStorageDefaults.LogoutRedirectRoute);
    }

    console.log('Logout Redirect', redirectRoute);
    const targetRoute = redirectRoute ?? '/';
    this.router.navigate([targetRoute]);
  }

}
